import { useScannedRelevosContext } from './hooks';
import { ScannedRelevosContext, ScannedRelevosContextProvider } from './ScannedRelevosContext';

const ASSIGN_RETURN_RESTAURANT_ID_LS_KEY = 'assignReturnRestaurantId';
const DELIVERY_NOTE_ENABLED_KEY = 'deliveryNoteEnabled';
export {
  ASSIGN_RETURN_RESTAURANT_ID_LS_KEY,
  DELIVERY_NOTE_ENABLED_KEY,
  ScannedRelevosContext,
  ScannedRelevosContextProvider,
  useScannedRelevosContext,
};
